var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { initialState } from './../../resultboard/model/resultboard';
import { USER_LOGIN, USER_LOGOUT, LEAGUE_DATA, LEAGUE_ID, LEAGUE_SCORE_DATA, MY_TEAM_DATA, SCORE_DATA, ROSTER_DATA, MINI_LOBBY_DATA, GAME_POSITION_DATA, BEST_BALL_PICK_COUNT, TOURNAMENT_MINI_LOBBY_DATA, SOUND_TOGGLE, DRAFT_TURN, DEAFULT_RANK_TOGGLE, PICKED_PLAYERS, PICK_NUMBER, PLAYERS_LIST_DATA, DRAFT_STATUS_DATA, CURRENT_TOURNAMENT_DATA, MOBILE_SCREEN, AUTH_USER, LOG_OUT, LOG_IN, DRAFT_POSITIONS, AUTO_DRAFT_ENABLE, BYE_WEEK, DARK_MODE, USER_BALANCE } from './../../store/actions/appActions';
export function reducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case USER_LOGIN:
            return [action.payload];
        case USER_LOGOUT:
            return state.filter(function (_a) {
                var user_id = _a.user_id;
                return user_id !== action.user_id;
            });
        default:
            return state;
    }
}
export function leaguereducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case LEAGUE_ID:
            return [action.payload];
        default:
            return state;
    }
}
export function draftReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case LEAGUE_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function draftScoreReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case LEAGUE_SCORE_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function myTeamReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case MY_TEAM_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function rosterPositionReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case ROSTER_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function leagueScoreReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case SCORE_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function joinDarftMiniLobbyReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case MINI_LOBBY_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function joinTournamentMiniLobbyReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case TOURNAMENT_MINI_LOBBY_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function gamePositionFilters(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case GAME_POSITION_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function bestBallPickedCount(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case BEST_BALL_PICK_COUNT:
            return [action.payload];
        default:
            return state;
    }
}
export function soundOnOff(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case SOUND_TOGGLE:
            return [action.payload];
        default:
            return state;
    }
}
export function setDeafultRank(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case DEAFULT_RANK_TOGGLE:
            return [action.payload];
        default:
            return state;
    }
}
export function userDraftTurn(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case DRAFT_TURN:
            return [action.payload];
        default:
            return state;
    }
}
export function pickedPlayerList(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case PICKED_PLAYERS:
            return [action.payload];
        default:
            return state;
    }
}
export function currentPickNumber(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case PICK_NUMBER:
            return [action.payload];
        default:
            return state;
    }
}
export function playersListReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case PLAYERS_LIST_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function changeInDraft(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case DRAFT_STATUS_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function currTournamentData(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case CURRENT_TOURNAMENT_DATA:
            return [action.payload];
        default:
            return state;
    }
}
export function mobileScreenData(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case MOBILE_SCREEN:
            return [action.payload];
        default:
            return state;
    }
}
export function anthUserData(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case AUTH_USER:
            return [action.payload];
        default:
            return state;
    }
}
export function userBalanceData(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case USER_BALANCE:
            return [action.payload];
        default:
            return state;
    }
}
export function reducerUser(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case LOG_OUT: {
            return __assign({}, state, { isLoggedIn: false });
        }
        case LOG_IN: {
            return __assign({}, state, { isLoggedIn: true });
        }
        default: {
            return state;
        }
    }
}
export function positionsRemovedData(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case DRAFT_POSITIONS:
            return [action.payload];
        default:
            return state;
    }
}
export function isAutoDraftEnable(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case AUTO_DRAFT_ENABLE:
            return [action.payload];
        default:
            return state;
    }
}
export function byeWeekList(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case BYE_WEEK:
            return [action.payload];
        default:
            return state;
    }
}
export function DarkModeReducer(state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case DARK_MODE:
            return [action.payload];
        default:
            return state;
    }
}
